import React, { useState } from 'react';
import { ConfirmationStepProps } from '../types';

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  formik,
  contactsSelected,
  sanitizedTemplate,
  channelType
}) => {
  const [showContactsDropdown, setShowContactsDropdown] = useState(false);

  return (
    <div className="flex-1 min-h-[calc(100vh-220px)] max-h-[calc(100vh-220px)] sm:min-h-[calc(100vh-210px)] sm:max-h-[calc(100vh-210px)] p-2 sm:p-4 w-full mx-auto bg-white shadow-sm rounded-lg mb-4">
      <div className=''>
        <h5 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg">Review and Confirm Campaign Delivery</h5>
        <div className='flex gap-3 sm:gap-5'>
          <div className="mb-3 sm:mb-4">
            <p className="font-bold text-sm sm:text-base">Campaign Name:</p>
            <p className="text-sm sm:text-base">{formik.values.name}</p>
          </div>

          <div className="mb-3 sm:mb-4">
            <p className="font-bold text-sm sm:text-base">Email Subject:</p>
            <p className="text-sm sm:text-base">{formik.values.subject}</p>
          </div>

          <div className="mb-3 sm:mb-4 relative">
            <p className="font-bold text-sm sm:text-base">Target Audience:</p>
            <div className="flex items-center gap-2">
              <p className="text-sm sm:text-base">Active clients ({contactsSelected.length})</p>
              <button
                type="button"
                onClick={() => setShowContactsDropdown(!showContactsDropdown)}
                className="px-3 py-1 text-xs sm:text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                View
              </button>
            </div>

            {showContactsDropdown && (
              <div className="absolute top-full left-0 mt-2 w-64 sm:w-80 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 overflow-y-auto z-10">
                <div className="p-2">
                  <div className="flex justify-between items-center mb-2 pb-2 border-b">
                    <span className="font-semibold text-sm">Contact List</span>
                    <button
                      type="button"
                      onClick={() => setShowContactsDropdown(false)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      ✕
                    </button>
                  </div>
                  {contactsSelected.length > 0 ? (
                    <ul className="space-y-1">
                      {contactsSelected.map((contact: any, index: number) => (
                        <li key={index} className="text-xs sm:text-sm py-1 px-2 hover:bg-gray-50 rounded">
                          {channelType === 'Email' ? `${contact.name} (${contact.email || 'N/A'})` : `${contact.name || 'N/A'}  (${contact.phoneNumber || 'N/A'})`}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-gray-500">No contacts selected</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Email Template */}
        <div className="mb-4 !max-h-full">
          <p className="font-bold mb-2 sm:mb-3 text-sm sm:text-base">Email Template:</p>
          <div className="h-[calc(100vh-520px)] sm:h-[calc(100vh-380px)] min-h-[294px] sm:min-h-[180px] max-h-[calc(100vh-520px)] sm:max-h-[calc(100vh-380px)] border border-gray-300 rounded-lg p-2">
            <div className='h-full'>
              <div className='h-full overflow-y-auto'>
                <div
                  className="text-sm sm:text-base whitespace-pre-line"
                  dangerouslySetInnerHTML={{ __html: sanitizedTemplate }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationStep;
